
import {defineComponent, PropType} from "vue";
import BaseTitle from "@/components/UI/BaseTitle.vue";
import InputText from "@/components/UI/InputText.vue";
import {CodeDescriptionRestDto} from "@/api/pharma-cpc-mgmt/models";
import {FormMixin} from "@/components/base/FormMixin";
import GenericFormWrapper from "@/components/base/GenericFormWrapper.vue";
import {CommTypeEnum} from "@/api/enums/comm-type-enum";
import {I18nContext} from "@/context/I18nContext";
import InputTextEditor from "@/components/UI/InputTextEditor.vue";
import {NotificationTemplateRestService} from "@/services/rest/master/NotificationTemplateRestService";
import {DpModuleEnum} from "@/api/enums/dp-module-enum";
import {Storage} from "@/models/facade/Storage";
import {SessionStorageKeyEnum} from "@/models/enum/SessionStorageKeyEnum";
import {
  NotificationTemplateOverviewRestDto,
} from "@/api/pharma-master-notification-template/models";
import {handleSavedSuccessfully} from "@/helpers/toast-helper";
import BaseOffcanvasButtonClose from "@/components/UI/Bootstrap/Offcanvas/BaseOffcanvasButtonClose.vue";
import {EnumRestService} from "@/services/rest/enum/EnumRestService";
import {NotificationTemplateMixin} from "@/components/layouts/notification-template/NotificationTemplateMixin";
import {
  NotificationTemplateRestDtoModel
} from "@/models/api/pharma-master-notification-template/NotificationTemplateRestDtoModel";

export default defineComponent({
  name: "NotificationTemplateDetail",
  emits: ['update'],
  mixins: [FormMixin, NotificationTemplateMixin],
  components: {
    BaseOffcanvasButtonClose,
    InputTextEditor,
    GenericFormWrapper,
    InputText,
    BaseTitle,
  },
  props: {
    notificationTemplate: {
      type: Object as PropType<NotificationTemplateOverviewRestDto>,
      required: false
    },
    moduleCode: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      module: DpModuleEnum.ORDER,
      allNotificationTypes: [] as CodeDescriptionRestDto[],
      allCommunicationTypes: [] as CodeDescriptionRestDto[],
      allLanguages: [] as CodeDescriptionRestDto[],
      template: NotificationTemplateRestDtoModel.createWithDefaults(),
    }
  },
  mounted() {
    this.initialize();
  },
  computed: {
    notificationType(): string {
      if (!this.notificationTemplate) {
        return '';
      }
      return this.allNotificationTypes
        .find((typeCode: any) => typeCode.code === this.notificationTemplate!.type_code)
        ?.description ?? this.notificationTemplate!.type_code;
    },
  },
  methods: {
    async doInitialize(): Promise<void> {
      this.module = Storage.session.get(SessionStorageKeyEnum.NOTIFICATION_TEMPLATE_MODULE) ?? DpModuleEnum.ORDER;
      this.allCommunicationTypes = [
        {code: CommTypeEnum.EMAIL, description: this.$t('email')},
        {code: CommTypeEnum.SMS, description: this.$t('sms')}
      ];
      this.allLanguages = I18nContext.getLanguages()?.map((language: string) => {
        return {code: language, description: language};
      });
      this.allNotificationTypes = await EnumRestService.getInstance()
        .getEnumValuesByClassName(this.getNotificationTypeEnum(this.moduleCode), this.moduleCode);
    },
    async doSubmit(): Promise<void> {
      await NotificationTemplateRestService.getInstance().updateNotificationTemplate(this.notificationTemplate!.id, this.template, this.module);
    },
    async doReload(): Promise<void> {
      if (!this.notificationTemplate) {
        this.template = NotificationTemplateRestDtoModel.createWithDefaults();
        return;
      }
      this.template = new NotificationTemplateRestDtoModel(
        this.notificationTemplate.comm_type_code,
        this.notificationTemplate.language_code,
        this.notificationTemplate.content,
        this.notificationTemplate.subject ?? ''
      );
    },
    async afterSave(message?: string): Promise<void> {
      this.$emit('update');
      await handleSavedSuccessfully(message);
    },
  }
});
